import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { fetchJson } from "../../../../helpers";

import {update_task_marker_path} from '~/routes';

export const MARKER_COLORS = {
  0: 'inherit', // null
  1: '#006b99',
  2: '#9f2a79',
  3: '#f64d62',
  4: '#e17572',
  5: '#7eae74',
  6: '#78bedb',
};

export const markerCellRenderer = (params) => {
  const currentMarkerId = params.getValue() ?? 0;
  const [selectedMarkerId, setSelectedMarkerId] = useState(currentMarkerId.toString());

  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const menuRef = useRef(null);
  const [pos, setPos] = useState({ top: 0, left: 0, width: 0 });

  const taskId = ((params.data || {})[params.colDef.colId] || {})["task_id"];

  const markerColor = MARKER_COLORS[selectedMarkerId]
  const className = selectedMarkerId === '0' ? 'fa fa-plus' : 'fa fa-flag';

  useEffect(() => {
    if (!open) return;

    const rect = buttonRef.current?.getBoundingClientRect();
    if (rect) {
      const menuW = 30;
      setPos({
        top: (rect.bottom + window.scrollY),
        left: (rect.left + window.scrollX) + rect.width / 2 - menuW / 2,
        width: menuW,
      });
    }

    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(e.target)
      ) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [open]);

  const handleButtonClick = () => setOpen((o) => !o);

  const handleSelect = (taskId, markerId) => {
    setSelectedMarkerId(markerId);
    setOpen(false);

    fetchJson(update_task_marker_path(), {
      method: 'POST', 
      body: JSON.stringify({marker_id: markerId, task_id: taskId})
    });
  };

  const menu = open
    ? createPortal(
        <div
          ref={menuRef}
          className="marker-menu"
          style={{
            top: pos.top,
            left: pos.left,
            width: pos.width,
          }}
        >
          {Object.entries(MARKER_COLORS).map(([markerId, itemColor]) => {
            const itemClass = markerId === '0' ? 'fa fa-minus' : 'fa fa-flag';
            return (
              <div
                key={markerId}
                className="marker-menu-item"
                onClick={() => handleSelect(taskId, markerId)}
                style={{
                  background: markerId === selectedMarkerId ? '#e6f7ff' : 'transparent',
                }}
              >
                <i className={itemClass+' marker-icon'}
                  style={{ color: itemColor }}
                  >
                  </i>
              </div>
            );
          })}
        </div>,
        document.body
      )
    : null;

  return (
    <div className="marker-button-container">
      <button
        ref={buttonRef}
        type="button"
        className={className + ' marker-button marker-icon'}
        onClick={handleButtonClick}
        style={{color: markerColor}}
      />
      {menu}
    </div>
  );
};

export const markerFilterCellRenderer = (params) => {
  const value = params.value
  const markerColor = MARKER_COLORS[value] ?? 'none'
  const className = `fa fa-${value === '0' ? 'minus' : 'flag'} marker-icon`
  if(value === '(Select All)') {
    return value;
  }
  return <i className={className} style={{color: markerColor}} />
};